import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-dialog-footer',
  templateUrl: './dialog-footer.component.html',
  styleUrls: ['./dialog-footer.component.scss'],
})
export class DialogFooterComponent {
  @Input() cancelLabel = 'Cancel';
  @Input() submitLabel = 'Save';
  @Input() loadingLabel = 'Loading';
  @Input() submitDisabled = false;
  @Input() loading = false;

  @Output() cancel = new EventEmitter<void>();
  @Output() submit = new EventEmitter<void>();
}
